import { Image } from "react-bootstrap"
import project1 from "../images/orbit.webp"
import project2 from "../images/Wonderhouseth.png"
import project3 from "../images/myst.png"
import project4 from "../images/therich.png"
import project5 from "../images/colorhub.jpg"
import project6 from "../images/333.jpg"
import project7 from "../images/thaimeup.png"
import project8 from "../images/lebrandname.jpg"
import project9 from "../images/idoneartteam.png"
import project10 from "../images/zoolution.jpg"
import project11 from "../images/accinfinity.png"
import project12 from "../images/HiwSeafood.png"
import project13 from "../images/Fireground.jpg"
import project14 from "../images/dmark.webp"
import project15 from "../images/Mines789.jpg"

import { Row, Col } from 'react-bootstrap';

const wordpress = [
    {
        id: 1,
        pic: project1,
        href: 'https://orbitacc.com/',
    },
    {
        id: 2,
        pic: project2,
        href: 'https://wonderhouseth.com/',
    },
    {
        id: 3,
        pic: project3,
        href: 'http://myst-homeoffice.com/',
    },
    {
        id: 4,
        pic: project4,
        href: 'https://www.cmc.co.th/therich-rama2/',
    },
    {
        id: 5,
        pic: project5,
        href: '/colorhub',
    },
    {
        id: 6,
        pic: project6,
        href: '/web333',
    },
    {
        id: 7,
        pic: project7,
        href: 'https://thaimeupkitchen.com.au/'
    },
    {
        id: 8,
        pic: project8,
        href: '/lebrandname'
    },
    {
        id: 9,
        pic: project9,
        href: 'https://idoneartteam.com/'
    },
    {
        id: 10,
        pic: project10,
        href: '/zoolution'
    },
    {
        id: 11,
        pic: project11,
        href: 'https://accinfinity.com/'
    },
    {
        id: 12,
        pic: project12,
        href: 'https://hiwseafood.com/'
    },
    {
        id: 13,
        pic: project13,
        href: '/fireground'
    },
    {
        id: 14,
        pic: project14,
        href: 'https://dmark.so/'
    },
    {
        id: 15,
        pic: project15,
        href: '/mines789'
    },
]

export default function WordpressProjects() {
    return (
        <Row className="g-4 m-center">
            {wordpress.map((wp) => (
                <Col
                    key={wp.id}
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={6}
                    xs={12}
                    className="d-flex justify-content-center py-2 hover-soak"
                >
                    <a href={wp.href} target="_blank" rel="noopener noreferrer" className="w-100">
                        <div className="h-100">
                            <Image
                                alt="Figma icon"
                                src={wp.pic}
                                className="img-fluid custom-rounded"
                                width="100%"
                            />
                        </div>
                    </a>
                </Col>
            ))}
        </Row>

    )
}